import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useLanguage } from "../contexts/LanguageContext";

export default function TermsPage() {
  const { lang } = useLanguage();
  const isTR = lang === "tr";

  return (
    <div className="min-h-screen bg-cream text-ink" data-testid="terms-page">
      <Helmet>
        <title>{isTR ? "Kullanım Koşulları — Yastık Medya" : "Terms of Use — Yastık Medya"}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Header />
      <main className="container-page py-20 max-w-3xl">
        <h1 className="font-display text-display-2 font-bold text-ink mb-8">
          {isTR ? "Kullanım Koşulları" : "Terms of Use"}
        </h1>
        <div className="prose prose-ink max-w-none space-y-6 text-ink/80 leading-relaxed">
          <p className="text-ink/50 text-sm">{isTR ? "Son güncelleme: Mayıs 2026" : "Last updated: May 2026"}</p>

          <section>
            <h2 className="font-display text-h2 font-semibold text-ink mt-8 mb-3">
              {isTR ? "1. Hizmet Kapsamı" : "1. Scope of Service"}
            </h2>
            <p>
              {isTR
                ? "Yastık Medya, dijital pazarlama, sosyal medya yönetimi, SEO ve kreatif tasarım hizmetleri sunmaktadır. Sözleşme kapsamındaki hizmetler, müşteri ile imzalanan hizmet sözleşmesinde belirtilen koşullara tabidir."
                : "Yastık Medya provides digital marketing, social media management, SEO, and creative design services. Services covered by the contract are subject to the terms specified in the service agreement signed with the client."}
            </p>
          </section>

          <section>
            <h2 className="font-display text-h2 font-semibold text-ink mt-8 mb-3">
              {isTR ? "2. Fikri Mülkiyet" : "2. Intellectual Property"}
            </h2>
            <p>
              {isTR
                ? "Yastık Medya tarafından üretilen tüm içerik, tasarım ve kreatif materyaller, müşteriye teslim edilene kadar Yastık Medya'nın fikri mülkiyetinde kalmaktadır. Teslim sonrası haklar hizmet sözleşmesinde belirlenir."
                : "All content, designs, and creative materials produced by Yastık Medya remain the intellectual property of Yastık Medya until delivered to the client. Post-delivery rights are defined in the service agreement."}
            </p>
          </section>

          <section>
            <h2 className="font-display text-h2 font-semibold text-ink mt-8 mb-3">
              {isTR ? "3. Sorumluluk Sınırları" : "3. Limitation of Liability"}
            </h2>
            <p>
              {isTR
                ? "Yastık Medya, dijital reklam platformlarının (Meta, Google vb.) politika değişikliklerinden, hesap askıya almalarından veya üçüncü taraf hizmetlerin kesintilerinden kaynaklanan doğrudan ya da dolaylı zararlardan sorumlu tutulamaz."
                : "Yastık Medya cannot be held liable for direct or indirect damages arising from policy changes of digital advertising platforms (Meta, Google, etc.), account suspensions, or interruptions in third-party services."}
            </p>
          </section>

          <section>
            <h2 className="font-display text-h2 font-semibold text-ink mt-8 mb-3">
              {isTR ? "4. İletişim" : "4. Contact"}
            </h2>
            <p>
              {isTR
                ? "Kullanım koşullarına ilişkin sorularınız için "
                : "For questions about our terms of use, please contact us at "}
              <a href="mailto:merhaba@yastikmedya.com" className="text-brand-pink hover:underline">
                merhaba@yastikmedya.com
              </a>
              {isTR ? " adresinden bize ulaşabilirsiniz." : "."}
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
